export default "__VITE_ASSET__k1FORafE__"